import { Axis } from '@devexpress/dx-react-chart';
import { withClassName } from '../utils';

export const Root = withClassName('dx-c-bs4-crisp-edges')(Axis.Root);
